import {
    Autocomplete,
    Box,
    Checkbox,
    FormControlLabel,
    FormLabel,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography } from "../../ui";
import React,
    { useMemo } from "react";
import {
  BillStatus,
  CART_INITIAL_STATE,
  CASHPAY,
  isEmpty,
  isNumberEmpty,
  ONLINEPAY
} from "../../../constants/constant";
import { INITIAL_PARTIAL_PAY } from "../resto-billing/RestBillConstants";

const DialogPartialPay = ({
    partialPay,
    duesAmt,
    billStatus,
    currDues,
    partialPayList,
    setPartialPay,
    setCurrDues,
    fireSnackBarMsg
}) => {

    const handleSelectChange = (_, payMethod) => {
        //printLog("handleSelectChange", payMethod);
        if (payMethod != null) {
            setPartialPay(prev => ({
                ...prev,
                onlineBillPaidThrough: payMethod,
            }));
        } else {
            setPartialPay(prev => ({
                ...prev,
                onlineBillPaidThrough: "",
            }));
        }
    };

    const memorizedEnableDisableOnlineCashPay = useMemo(() => {
        return (
            billStatus !== BillStatus.PAID &&
            (isEmpty(partialPay.onlineBillPaidThrough) || isEmpty(partialPay.cashBillPaidThrough))
        );
    }, [billStatus, partialPay.onlineBillPaidThrough, partialPay.cashBillPaidThrough]);

    const getPartialPaidThrough = (val) => {
        if (val.onlineBillPaidThrough && val.cashBillPaidThrough) {
            return val.onlineBillPaidThrough + "(" + val.onlinePay + ") " + val.cashBillPaidThrough + "(" + val.cashPay + ")";
        } else if (val.onlineBillPaidThrough) {
            return val.onlineBillPaidThrough;
        } else {
            return val.cashBillPaidThrough;
        }
    };

    const handlePartialPayChange = (event) => {
        const { name, value } = event.target;
        //printLog("handlePartialPayChange", name, value);
        if (name === 'partialAmt') {
            if (!isNumberEmpty(value)) {
                if (Number(value) > Number(duesAmt)) {
                    fireSnackBarMsg({msg:`Exceeds Remaining Amt i.e ${duesAmt}`});
                    setCurrDues(0.0);
                    setPartialPay(INITIAL_PARTIAL_PAY);
                } else {
                    const dues = Number(duesAmt) - Number(value);
                    setPartialPay(prev=> ({
                        ...prev,...INITIAL_PARTIAL_PAY,
                        partialAmt: Number(value),
                    }));
                    setCurrDues(dues);
                }
            } else {
                setCurrDues(0.0);
                setPartialPay(INITIAL_PARTIAL_PAY);
            }

        } else if (name === 'cashPayAmt') {
            const rt = partialPay.partialAmt;
            if (isEmpty(value)) {
                setPartialPay(prev=> ({
                    ...prev,
                    cashPay: 0.0,
                    onlinePay: (isEmpty(prev.onlineBillPaidThrough)) ? 0.0 : rt,
                    cashTendered: 0, cashReturn: 0,
                }));
            } else {
                if (Number(value) > rt) {
                    fireSnackBarMsg({msg:`Exceeds Remaining Amt i.e ${rt}`});
                } else {
                    const mOnlinePay = (!isEmpty(partialPay.onlineBillPaidThrough)) ? (rt - Number(value)) : 0.0;
                    setPartialPay(prev=> ({
                        ...prev,
                        cashPay: Number(value),
                        onlinePay: mOnlinePay,
                        onlineBillPaidThrough: (mOnlinePay === 0.0) ? "" : prev.onlineBillPaidThrough
                        , cashTendered: 0, cashReturn: 0,
                    }));
                }
            }
        } else if (name === 'cashPay') {
            //printLog("cashPay",partialPay);
            const val = (isEmpty(partialPay.cashBillPaidThrough)) ? CASHPAY : '';
            //printLog("val",val);
            const rt = partialPay.partialAmt;
            if (rt > 0) {
                setPartialPay(prev=> ({
                    ...prev,
                    cashBillPaidThrough: val,
                    cashPay: (!isEmpty(prev.onlineBillPaidThrough)) ? (!isEmpty(val)) ? (rt / 2) : 0.0 : (!isEmpty(val)) ? rt : 0.0,
                    onlinePay: (!isEmpty(prev.onlineBillPaidThrough)) ? (!isEmpty(val)) ? (rt / 2) : rt : 0.0,
                    cashTendered: 0, cashReturn: 0,
                }));
            } else {
                fireSnackBarMsg({msg:"Please enter cash amount"});
            }

        } else if (name === 'onlinePay') {
            //printLog("CART_INITIAL_STATE.onlinePayMethod",CART_INITIAL_STATE.onlinePayMethod);
            const val = (isEmpty(partialPay.onlineBillPaidThrough)) ? CART_INITIAL_STATE.onlinePayMethod[0] : '';
            const rt = partialPay.partialAmt;
            if (rt > 0) {
                setPartialPay(prev=> ({
                    ...prev,
                    onlineBillPaidThrough: val,
                    cashPay: (!isEmpty(prev.cashBillPaidThrough)) ? (!isEmpty(val)) ? (rt / 2) : rt : 0.0,
                    onlinePay: (!isEmpty(prev.cashBillPaidThrough)) ? (!isEmpty(val)) ? (rt / 2) : 0.0 : (!isEmpty(val)) ? rt : 0.0,
                    cashTendered: 0, cashReturn: 0,
                }));
            } else {
                fireSnackBarMsg({msg:"Please enter online amount"});
            }
        } else if (name === 'onlinePayAmt') {
            const rt = partialPay.partialAmt;
            if (isEmpty(value)) {
                setPartialPay(prev=> ({
                    ...prev,
                    cashPay: (isEmpty(prev.cashBillPaidThrough)) ? 0.0 : rt,
                    onlinePay: 0.0,
                    cashTendered: 0, cashReturn: 0,
                }));
            } else {
                if (Number(value) > rt) {
                    fireSnackBarMsg({msg:`Exceeds Remaining Amt i.e ${rt}`});
                } else {
                    const mCashPay = (!isEmpty(partialPay.cashBillPaidThrough)) ? (rt - Number(value)) : 0.0;
                    setPartialPay(prev=> ({
                        ...prev,
                        onlinePay: Number(value),
                        cashPay: mCashPay,
                        cashBillPaidThrough: (mCashPay === 0.0) ? "" : prev.cashBillPaidThrough
                        , cashTendered: 0, cashReturn: 0,
                    }));
                }
            }
        } else if (name === 'cashTender') {
            if (isNumberEmpty(value)) {
                setPartialPay(prev=> ({
                    ...prev,
                    cashTendered: 0.0,
                    cashReturn: 0.0,
                }));
            } else {
                const tot = !isEmpty(partialPay.onlineBillPaidThrough) ? partialPay.cashPay : partialPay.partialAmt;
                const rt = Number(value) - tot;
                if (rt >= 0.0) {
                    setPartialPay(prev=> ({
                        ...prev,
                        cashTendered: Number(value),
                        cashReturn: rt,
                    }));
                } else {
                    setPartialPay(prev=> ({
                        ...prev,
                        cashTendered: Number(value),
                        cashReturn: rt,
                    }));
                    if (rt < 0.0) {
                        fireSnackBarMsg({msg:`Cash Tender should be more or same as Cash Amount i.e  ${tot}`});
                    }
                }
            }
        }
    };

    return (
        <>
            <Grid container spacing={1}
                justifyContent="center"
                alignItems="center" sx={{
                    padding: 0, margin: 0,
                }} >
                <Grid item md={7} xs={12} sm={12} >
                    <Typography variant="p" color="#02056e" fontWeight='bold'>Remaining Amt To Paid ₹{duesAmt}</Typography>
                </Grid>
                <Grid item md={4} sm={12} xs={12}>
                    <TextField style={{ width: "180px" }} value={partialPay.partialAmt}
                        id="partialAmt" name="partialAmt" disabled={billStatus === BillStatus.PAID
                            || billStatus === BillStatus.HOMEDELIVERYCASHPAY
                            || billStatus === BillStatus.HOMEDELIVERYPAY}
                        label="Enter Amount Paid" variant="filled" size="small" onChange={handlePartialPayChange} />
                </Grid>
                <Grid item md={4} xs={12} sm={12}>
                    <center>
                        <Typography variant="p" color="#3e0109" fontWeight='bold'>Current Remaining Dues ₹{currDues}</Typography></center>
                </Grid>

                <Grid item md={12} xs={12} sm={12}>
                    <FormLabel id="paymentMethod"> <p ><u>Payment Methods:</u> </p></FormLabel>
                </Grid>
                <Grid item xs={12} md={2} sm={6}>
                    <FormControlLabel disabled={billStatus === BillStatus.PAID} name="onlinePay" value={ONLINEPAY}
                        checked={(!isEmpty(partialPay.onlineBillPaidThrough))} control={<Checkbox />}
                        label="Online" onChange={handlePartialPayChange} />
                </Grid>
                <Grid item xs={12} md={5} sm={6}>
                    <Autocomplete
                        id="pOnline-select"
                        options={CART_INITIAL_STATE.onlinePayMethod}
                        autoHighlight
                        variant="filled"
                        size="small"
                        fullWidth
                        disabled={billStatus === BillStatus.PAID || isEmpty(partialPay.onlineBillPaidThrough)}
                        onChange={handleSelectChange}
                        isOptionEqualToValue={(option, value) => {
                            if (!option) return false;
                            if (!value) return false;
                            return (option === value);
                        }}
                        getOptionLabel={(option) => option || ''}
                        value={partialPay.onlineBillPaidThrough}
                        defaultValue={partialPay.onlineBillPaidThrough}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                {...props}
                                key={`${option}`}
                            >
                                {option}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search Online Pay Method"
                                inputProps={{
                                    ...params.inputProps,
                                }}
                            />
                        )}
                    />

                </Grid>
                <Grid item xs={12} md={5} sm={6}>
                    <TextField
                        id="onlinePayAmt"
                        name="onlinePayAmt"
                        variant="filled"
                        size="small"
                        fullWidth
                        disabled={memorizedEnableDisableOnlineCashPay}
                        label="Enter Online Amount"
                        value={partialPay.onlinePay}
                        onChange={handlePartialPayChange}
                    />
                </Grid>
                <Grid item xs={12} md={2} sm={6}>
                    <FormControlLabel name="cashPay" disabled={billStatus === BillStatus.PAID} 
                        value={CASHPAY} 
                        checked={partialPay.cashBillPaidThrough === CASHPAY} 
                        control={<Checkbox />} label="Cash" onChange={handlePartialPayChange} />
                </Grid>
                <Grid item xs={12} md={5} sm={6}>
                    <TextField
                        id="cashPayAmt"
                        name="cashPayAmt"
                        variant="filled"
                        size="small"
                        fullWidth
                        disabled={memorizedEnableDisableOnlineCashPay}
                        label="Enter Cash Amount"
                        value={partialPay.cashPay}
                        onChange={handlePartialPayChange}
                    />
                </Grid>
                <Grid item xs={12} md={5} sm={6}>
                    <TextField
                        id="cashTender"
                        name="cashTender"
                        variant="filled"
                        size="small"
                        fullWidth
                        disabled={billStatus === BillStatus.PAID || (isEmpty(partialPay.cashBillPaidThrough))}
                        label="Enter Cash Tender"
                        value={partialPay.cashTendered}
                        onChange={handlePartialPayChange}
                    />
                </Grid>
                <Grid item xs={12} md={5} sm={6}>
                    {
                        partialPay.cashReturn > 0.0 &&
                        <Typography variant="subtitle4" component="div" style={{ color: "#A52A2A" }}>
                            Cash Return: ₹{partialPay.cashReturn}</Typography>
                    }
                </Grid>
            </Grid>
            {(Array.isArray(partialPayList) && partialPayList.length > 0) &&
                <TableContainer component={Paper}>
                    <Table aria-label="simple table" className="rate_card">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Paid On</TableCell>
                                <TableCell align="center">Accept By</TableCell>
                                <TableCell align="center">Amount</TableCell>
                                <TableCell align="center">Paid Through</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {partialPayList.map((val, index) => {
                                return (
                                    <TableRow
                                        key={index}
                                        className="rate_card--row"
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{val.paidOn}</p></TableCell>
                                        <TableCell align="center">{val.paidAcceptBy}</TableCell>
                                        <TableCell align="center">{val.partialAmt}</TableCell>
                                        <TableCell align="center"><p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{getPartialPaidThrough(val)}</p></TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            }

        </>
    );
};

export default React.memo(DialogPartialPay);